/**
 * This function is used to handles spaces and cases when using Cyrpess Selectors. e.g. Active Resources becomes active-resources.
 *
 * @param selector string
 */
export const createCySelector = (selector = '') => selector.replace(/\s/g, '-').toLowerCase();
